module.exports = __webpack_public_path__ + "img/32.67a8214e.svg";